import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { FoundationElement, TabsOrientation } from '@microsoft/fast-foundation';
import { foundationStepperTabStyles as styles } from './stepper-tab.styles';
import { foundationStepperTabTemplate as template } from './stepper-tab.template';
/**
 * @tagname %%prefix%%-stepper-tab
 */
export class StepperTab extends FoundationElement {
    constructor() {
        super(...arguments);
        this.slot = 'tab';
        this.orientation = TabsOrientation.vertical;
    }
    isCompleted() {
        return this.completed;
    }
    selectedChanged() {
        if (this.treeItem) {
            this.treeItem.selected = this.selected;
        }
    }
}
__decorate([
    attr
], StepperTab.prototype, "slot", void 0);
__decorate([
    attr({ mode: 'boolean' })
], StepperTab.prototype, "selected", void 0);
__decorate([
    attr({ mode: 'boolean' })
], StepperTab.prototype, "completed", void 0);
__decorate([
    attr({ mode: 'boolean' })
], StepperTab.prototype, "error", void 0);
__decorate([
    attr({ mode: 'boolean' })
], StepperTab.prototype, "isLast", void 0);
__decorate([
    attr({ attribute: 'tab-position' })
], StepperTab.prototype, "tabPosition", void 0);
__decorate([
    attr
], StepperTab.prototype, "orientation", void 0);
// explicitly declaring for extensibility
export const foundationStepperTabShadowOptions = undefined;
export const defaultStepperTabConfig = {};
/**
 * The Foundation Stepper Tab
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-stepper-tab\>
 */
export const foundationStepperTab = StepperTab.compose(Object.assign({ baseName: 'stepper-tab', template,
    styles, shadowOptions: foundationStepperTabShadowOptions }, defaultStepperTabConfig));
